import React from 'react';

const Search: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="17"
    fill="none"
    viewBox="0 0 16 17"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d={`M2.5 8.33333C2.5 9.09938 2.65088 9.85792 2.94404 10.5657C3.23719
      11.2734 3.66687 11.9164 4.20854 12.4581C4.75022 12.9998 5.39328 13.4295
      6.10101 13.7226C6.80875 14.0158 7.56729 14.1667 8.33333 14.1667C9.09938
      14.1667 9.85792 14.0158 10.5657 13.7226C11.2734 13.4295 11.9164 12.9998
      12.4581 12.4581C12.9998 11.9164 13.4295 11.2734 13.7226 10.5657C14.0158
      9.85792 14.1667 9.09938 14.1667 8.33333C14.1667 7.56729 14.0158 6.80875
      13.7226 6.10101C13.4295 5.39328 12.9998 4.75022 12.4581 4.20854C11.9164
      3.66687 11.2734 3.23719 10.5657 2.94404C9.85792 2.65088 9.09938 2.5
      8.33333 2.5C7.56729 2.5 6.80875 2.65088 6.10101 2.94404C5.39328 3.23719
      4.75022 3.66687 4.20854 4.20854C3.66687 4.75022 3.23719 5.39328 2.94404
      6.10101C2.65088 6.80875 2.5 7.56729 2.5 8.33333Z`}
      stroke="#212121" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
    <path d="M17.5 17.5L12.5 12.5L17.5 17.5Z" fill="#212121"/>
    <path d="M17.5 17.5L12.5 12.5" 
      stroke="#212121" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
  </svg>
);

export default Search;
